<input
  #batchInput
  [id]="inputId"
  [disabled]="disabled"
  class="vis-grid-input"
  [class.error-cell]="hasFormatError"
  [value]="displayValue"
  maxlength="30"
  autocomplete="off"
  [matAutocomplete]="batchAuto"
  [placeholder]="allowCreate ? '搜尋批號或輸入新批號' : '搜尋批號'"
  (focus)="onFocus()"
  (blur)="onBlur()"
  (input)="onInput($event.target['value'])"
  (keydown.enter)="onEnterNew(keyword)"
  (keydown.tab)="tabPressed.emit($event)"
  (keydown.shift.tab)="tabPressed.emit($event)" />

<mat-autocomplete #batchAuto="matAutocomplete"
  [autoActiveFirstOption]="false"
  [panelWidth]="380"
  class="batch-select-panel">
  <!-- 載入中 -->
  <mat-option *ngIf="isLoading" disabled class="loading-option">
    載入中...
  </mat-option>
  <!-- 未選庫別: 提示先選庫別 (批號需依庫別載入庫存量) -->
  <mat-option *ngIf="!isLoading && !storeRoomId" disabled class="hint-option">
    請先選擇庫別
  </mat-option>
  <!-- 欄位標題 -->
  <mat-option *ngIf="!isLoading && _filteredOptions.length > 0" disabled class="header-option">
    <div class="batch-row batch-header">
      <span class="col-batch-no">批號</span>
      <span class="col-expiration">有效日期</span>
      <span class="col-qty">庫存量</span>
    </div>
  </mat-option>
  <!-- 無結果 -->
  <mat-option *ngIf="!isLoading && options.length > 0 && _filteredOptions.length === 0" disabled class="no-result-option">
    查無符合的批號
  </mat-option>
  <!-- 無可用批號且允許新增時提示 (已選庫別) -->
  <mat-option *ngIf="!isLoading && storeRoomId && options.length === 0 && allowCreate" disabled class="hint-option">
    搜尋批號或輸入新批號
  </mat-option>
  <!-- 批號清單 -->
  <mat-option *ngFor="let o of _filteredOptions" [value]="o.BatchNo"
    (onSelectionChange)="$event.isUserInput && onSelectExisting(o)">
    <div class="batch-row">
      <span class="col-batch-no"><app-stocks-batch-stop-icon
          [batch]="o"></app-stocks-batch-stop-icon><span class="batch-no-text">{{ o.BatchNo }}</span></span>
      <span class="col-expiration">{{ o.ExpirationDate | formatROCFullDate:'/' }}</span>
      <span class="col-qty">{{ displayQty(o) | number:'1.0-0':'en-US' }}</span>
    </div>
  </mat-option>
  <!-- 未指定溢流 (僅 allowUnassigned) -->
  <mat-option *ngIf="allowUnassigned && !isLoading && storeRoomId" [value]="'未指定'"
    (onSelectionChange)="$event.isUserInput && onSelectUnassigned()" class="unassigned-option">
    <div class="batch-row">
      <span class="col-batch-no text-danger">未指定</span>
      <span class="col-expiration"></span>
      <span class="col-qty" *ngIf="unassignedQty !== null && unassignedQty !== undefined">{{ unassignedQty | number:'1.0-0':'en-US' }}</span>
    </div>
  </mat-option>
</mat-autocomplete>
